import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  connect() {
    this.timeout = window.setTimeout(() => {
      Turbo.visit(window.location.href, { action: "replace" })
    }, 5000)
  }

  disconnect() {
    window.clearTimeout(this.timeout)
  }
}
